export enum PLACE_TYPE {
    NATION = "N",
    REGION = "R",
    PROVINCE = "P",
    CITY = "C",
    ZONE = "Z",
    LOCALITY = "L",
    AREA_OF_INTEREST = "I",
    AREA = "A",
    DISTRICT = "D"
}
